import {
  SnackbarContent as MuiSnackbarContent,
  type SnackbarContentProps as MuiSnackbarContentProps,
} from '@mui/material';

/**
 * @deprecated Do not use this component, Unify toasts are in progress.
 * Please reach out in #unify-design-system-support for a path forward.
 */
export const SnackbarContent = MuiSnackbarContent;
/**
 * @deprecated Do not use this component, Unify toasts are in progress.
 * Please reach out in #unify-design-system-support for a path forward. */
export type SnackbarContentProps = MuiSnackbarContentProps;
